import React, { MouseEvent, useEffect, useState } from 'react';
import { Title } from '../../../../component/title/Title';
import ButtonBackComponent from '../../../../component/buttton/ButtonBack.component';
import Table from '../../../../component/table/Table.component';
import { HEAD_CELL } from './utils/HEAD_CELL';
import Grid from '@material-ui/core/Grid';
import GridComponent from '../../../../component/grid/GridComponent.component';
import FormLabel from '../../../../component/input/FormLabel.component';
import { FormInput, FormInputMultiline, FormSelect } from '../../../../component/input/InputStyle';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonComponent from '../../../../component/buttton/Button.component';
import { useManagement } from '../../../../context/Management';
import {postDriver, postVehicle, getDrivers, getTypeVehicle, updateDrivers} from './RegisterVehicle.service';
import { Action, ACTION_EDIT } from '../../../../component/table/interfaces/TableInterface';
import ModalUpdate from './components/modal/ModalUpdate.component';
import useModal from '../../../../hooks/useModal';
import { InterfaceRegisterModal,TableInterface,TypeVehicleInterface } from './interface/InterfaceRegisterVehicle';
import { useSnackbar } from '../../../../context/Snackbar';
import { INITIAL_PAGINATION } from '../../../../component/table/component/pagination/utils/Pagination';
import { Pagination } from '../../../../component/table/interfaces/Pagination';
import { compare } from '../../../../utils/order/compare';
import ButtonFinish from '../../components/buttonFinish/ButtonFinish.component';
import FormFilter from './components/form/FormFilterRegisterVehicles.component'


const RegisterVehiclescomponent = () => {

    const {valueCd} = useManagement();
    const [open, addModal] = useModal();
    const { setSnackbar } = useSnackbar();
    const [viewVehicles, setViewVehicles] = useState(false);
    const [viewDriverVehiclesData, setViewDriverVehiclesData] = useState(false);
    const [vehiclePlate, setVehiclePlate] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [fleetType, setFleetType] = useState('');
    const [vehicleHeight, setVehicleHeight] = useState('');
    const [vehicleWidth, setVehicleWidth] = useState('');
    const [vehicleLength, setVehicleLength] = useState('');
    const [loadMaximum, setLoadMaximum] = useState('');
    const [cargoVolume, setCargoVolume] = useState('');
    const [numberCompartments, setNumberCompartments] = useState('');
    const [vehicleDescription, setVehicleDescription] = useState('');
    const [tableRegister, setTableRegister] = useState<TableInterface[]>([]);
    const [tableRegisterAux, setTableRegisterAux] = useState<TableInterface[]>([]);
    const [labelTypeVehicle, setLabelTypeVehicle] = useState<TypeVehicleInterface[]>([]);
    const [tableValue, setTableValue] = useState<any>([]);
    const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
    const [buttonFilter, setButtonFilter] = useState(false);
    const [idTruck, setIdTruck] = useState('')

    const handleInputDriverName = (e: any) => {
        const { value, name } = e.target;
        switch (name) {
            case 'PlacaVeiculo':
                setVehiclePlate(value.toUpperCase())
                break;

            case 'TipoVeiculo' :

                const typeWalkId = labelTypeVehicle.filter((item: TypeVehicleInterface) => {
                    return value === item.tipoVeiculo;
                });
                setVehicleType(value)
                setIdTruck(typeWalkId[0].id);
                break;

            case 'TipoFrota':
                setFleetType(value)
                break;

            case 'AlturaVeiculo':
                setVehicleHeight(value)
                break;

            case 'LarguraVeiculo':
                setVehicleWidth(value)
                break;

            case 'ComprimentoVeiculo':
                setVehicleLength(value)
                break;

            case 'CargaMaxima':
                setLoadMaximum(value)
                break;

            case 'VolumeCarga':
                setCargoVolume(value)
                break;

            case 'NumeroCompartimentos':
                setNumberCompartments(value)
                break;

            case 'DescricaoVeiculo':
                setVehicleDescription(value)
                break;
        }

    }

    const cleanInputs = () => {
        setVehiclePlate('');
        setVehicleType('');
        setFleetType('');
        setVehicleHeight('');
        setVehicleWidth('');
        setVehicleLength('');
        setLoadMaximum('');
        setCargoVolume('');
        setNumberCompartments('');
        setVehicleDescription('');
}

    const handleClickSave = async (e:any) =>{
        try {
            const data = {
                placa: vehiclePlate,
                tipoVeiculo: idTruck,
                veiculoInterno: fleetType,
                cd: valueCd,
                altura: vehicleHeight,
                largura: vehicleWidth,
                comprimento: vehicleLength,
                cargaMaxima: loadMaximum,
                volumeCarga: cargoVolume,
                compartimentos: numberCompartments,
                descricao: vehicleDescription
            }

             const res = await postVehicle(data);
            if (res) {
                setSnackbar({type: 'success', msg: 'Dados cadastrados com sucesso.'});
                cleanInputs();
                getTableRegisterDrivers();
            }
        } catch(error) {
            console.log(error);
            setSnackbar({type: 'error', msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível cadastrar os dados.'})
        }
    }

    useEffect(() =>{
        getLabelTypeVehicle();
        getTableRegisterDrivers();
    },[]);

    const getTableRegisterDrivers = async () => {
        try {
            const res = await getDrivers(`${valueCd}`);
            const table = res.data.map((item: TableInterface) => {
                const data = {
                    id: item.id,
                    nome: item.nome,
                    placa: item.placa,
                    tipoVeiculo: item.tipoVeiculo,
                    documento: item.documento
                }
                return data
            })
            setTableRegister(table)
            setTableRegisterAux(table);

        } catch(error) {
            console.log(error);
            setSnackbar({type: 'error', msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível mostrar a tabela.'})
        }
    }

    const getLabelTypeVehicle = async () => {
        try {
            const {data} = await getTypeVehicle();
            setLabelTypeVehicle(data);
        } catch(error) {
            console.log(error)
            setSnackbar({type: 'error', msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível mostrar os tipos de caminhão.'})
        }
    }
    const handleClickAction = (action: Action, value: InterfaceRegisterModal, index: number) => {
        if (action === ACTION_EDIT) {
            /* console.log('index editar',index)
            console.log('value editar', value) */
            addModal(!open);
            setTableValue(value)
        }
    }

    const closeModal = async (newNameDriver: string, newDocument: string, newVehiclePlate: string, newId: string) => {
        if (!newId) {
            try {
                const dataPost = {
                    nome: newNameDriver,
                    documento: newDocument,
                    veiculo: newVehiclePlate
                }
                /* console.log('data', dataPost); */
                const resPost = await postDriver(dataPost);
                 if (resPost) {
                    setSnackbar({type: 'success', msg: 'Dados inseridos com sucesso.'})
                    addModal(!open);
                    getTableRegisterDrivers();
                }
            } catch(error) {
                setSnackbar({type: 'error', msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível vincular o motorista à um veículo.'})
                console.log(error);
                addModal(!open);
            }
        } else {
            try {
                const dataPut = {
                    id: newId,
                    nome: newNameDriver,
                    documento: newDocument,
                    veiculo: newVehiclePlate
                }
                /* console.log('dataPut', dataPut); */
                const resPut = await updateDrivers(dataPut);
                if (resPut) {
                    setSnackbar({type: 'success', msg: 'Dados atualizados com sucesso.'})
                    addModal(!open);
                    getTableRegisterDrivers();
                }
            } catch(error) {
                setSnackbar({type: 'error', msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível vincular o motorista à um veículo.'})
                console.log(error);
                addModal(!open);
            }
        }
    }

    const visualizarMotorista = () =>{
        setViewVehicles(false);
        setViewDriverVehiclesData(!viewDriverVehiclesData);

    }

    const cadastroVeiculo = () =>{
        setViewVehicles(!viewVehicles);
        setViewDriverVehiclesData(false);
    }

    const pageSelect = (tableRegisterAux: TableInterface[]) => {
        if (pagination.page) {
            return tableRegisterAux.slice((pagination.page - 1) * 30, pagination.page * 30)
        }
        return tableRegisterAux;
    }

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPagination({ ...pagination, page: newPage + 1 });
    };

    const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
        const isAsc = pagination.sort === property && pagination.order === 1;
        setTableRegisterAux(tableRegisterAux.sort((a: any, b: any) => compare(a, b, property, isAsc ? -1 : 1)))
        setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
    };

    const handleSubmitSearch = (vehiclePlate: TableInterface) => {
        let tableVehiclePlate: TableInterface[] = [...tableRegister].filter((el: TableInterface) => {
            let includesName: boolean = !vehiclePlate.nome || String(el.nome).toLocaleLowerCase().includes(String(vehiclePlate.nome).toLocaleLowerCase());
            let includesPlate: boolean = !vehiclePlate.placa || String(el.placa).toLocaleLowerCase().includes(String(vehiclePlate.placa).toLocaleLowerCase());
            return includesName && includesPlate;
        });
        const empty: boolean = !vehiclePlate.nome && !vehiclePlate.placa;
        setTableRegisterAux(empty ? [...tableRegister] : tableVehiclePlate);
    };

    return (
        <>
            <ButtonBackComponent to="/gestao-de-patio" />
            <Title fontSize={30} fontWeigth='900' margin="0px 0px 20px 0px">Cadastro/Vinculo de Motorista e Veículo</Title>
            <Grid item xs={12} sm={12} md={12} >
                <GridComponent justify="flex-start" alignItems="flex-start">
                    <ButtonComponent
                        color={viewVehicles ? 'secondary' : 'primary'}
                        margin="0px 0px 20px 10px"
                        title="Adicionar Veículo"
                        onClick={cadastroVeiculo}
                    />
                    <ButtonComponent
                        color={viewDriverVehiclesData ? 'secondary' : 'primary'}
                        margin="0px 0px 40px 10px"
                        title="Vincular Motorista/Veiculos"
                        onClick={visualizarMotorista}
                    />
                </GridComponent>
            </Grid>
            <GridComponent justify="flex-start" alignItems="flex-start" spacing={2} >
                {viewVehicles && <Grid item xs={12} sm={12} md={12} >
                    <Title fontSize={25} fontWeigth='900' margin="0px 0px 20px 20px">Cadastro Veículo</Title>
                    <GridComponent justify="flex-start" alignItems="center" spacing={2} >
                        <FormLabel title="Placa veículo" sm={10} md={5} lg={2} required>
                            <FormInput
                                name="PlacaVeiculo"
                                value={vehiclePlate}
                                placeholder="Ex... ABC-1234"
                                onChange={handleInputDriverName}
                                required
                            />
                        </FormLabel>
                        <FormLabel title="Tipo de Veículo" sm={12} md={5} lg={2} >
                            <FormSelect
                                name="TipoVeiculo"
                                value={vehicleType}
                                defaultValue={""}
                                displayEmpty={true}
                                onChange={handleInputDriverName}
                            >
                                <MenuItem disabled value="">Tipo de Veiculo</MenuItem>
                                {labelTypeVehicle.map((item:TypeVehicleInterface, index:number) => (
                                <MenuItem key={index} value={item.tipoVeiculo}>{item.tipoVeiculo}</MenuItem>
                                ))}

                            </FormSelect>
                        </FormLabel>
                        <FormLabel title="Tipo da Frota" sm={12} md={5} lg={2} >
                            <FormSelect
                                name="TipoFrota"
                                value={fleetType}
                                defaultValue={""}
                                displayEmpty={true}
                                onChange={handleInputDriverName}
                                required
                            >
                                <MenuItem disabled value="">Tipo Frota</MenuItem>
                                <MenuItem value={"S"}>Interno</MenuItem>
                                <MenuItem value={"N"}>Externo</MenuItem>
                            </FormSelect>
                        </FormLabel>
                        <FormLabel title="Alt.Veículo (m)" sm={12} md={5} lg={2} required>
                            <FormInput
                                name="AlturaVeiculo"
                                value={vehicleHeight}
                                placeholder="Altura do Veículo"
                                onChange={handleInputDriverName}
                                required
                            />
                        </FormLabel>
                        <FormLabel title="Larg.Veículo (m)" sm={12} md={5} lg={2} required>
                            <FormInput
                                name="LarguraVeiculo"
                                value={vehicleWidth}
                                placeholder="Largura do Veículo"
                                onChange={handleInputDriverName}
                                required
                            />
                        </FormLabel>
                        <FormLabel title="Comp. Veículo (m)" sm={12} md={5} lg={3} required>
                            <FormInput
                                name="ComprimentoVeiculo"
                                value={vehicleLength}
                                placeholder="Comprimento do Veículo"
                                onChange={handleInputDriverName}
                                required
                            />
                        </FormLabel>
                        <FormLabel title="Carga Max. (kg)" sm={12} md={5} lg={2} required>
                            <FormInput
                                name="CargaMaxima"
                                value={loadMaximum}
                                placeholder="Carga Máxima"
                                onChange={handleInputDriverName}
                                required
                            />
                        </FormLabel>

                        <FormLabel title="Volume Carga (m³)" sm={12} md={5} lg={3} required>
                            <FormInput
                                name="VolumeCarga"
                                value={cargoVolume}
                                placeholder="Volume Carga"
                                onChange={handleInputDriverName}
                                required
                            />
                        </FormLabel>
                        <FormLabel title="N° Compartimentos" sm={12} md={5} lg={3} required>
                            <FormInput
                                name="NumeroCompartimentos"
                                value={numberCompartments}
                                placeholder="Numero de Compartimentos"
                                onChange={handleInputDriverName}
                                required
                            />
                        </FormLabel>
                        <FormLabel title="Descrição do veiculo" sm={12} md={5} lg={4} required>
                            <FormInputMultiline
                                name="DescricaoVeiculo"
                                value={vehicleDescription}
                                placeholder="Descrição breve..."
                                minRows="2"
                                inputProps={{ maxLength: 40 }}
                                onChange={handleInputDriverName}
                                required
                            />
                        </FormLabel>
                    </GridComponent>
                </Grid>}
            </GridComponent>
            {viewVehicles && <GridComponent justify="flex-start" >
                <ButtonComponent
                    margin='10px 0 0 0'
                    title="Cadastrar"
                    onClick={handleClickSave}
                />
            </GridComponent>}
            {open && <ModalUpdate open={!!open} handleClick={() => addModal(!open)} onClickSubmit={closeModal} data={tableValue}/>}
            {viewDriverVehiclesData && <GridComponent justify='flex-end' margin='50px 0px 0px 0px'>
                <ButtonFinish name="filtrar" onClick={()=> setButtonFilter(!buttonFilter)}>Filtrar</ButtonFinish>
            </GridComponent>}
            {viewDriverVehiclesData && <GridComponent justify="flex-start" margin='0px 0px 20px 0px'>
                {buttonFilter && <FormFilter handleSubmitForm={handleSubmitSearch}/>}
            </GridComponent>}
            {viewDriverVehiclesData && <Table
                headCells={HEAD_CELL}
                data={pageSelect(tableRegisterAux)}
                page={pagination.page}
                size={tableRegisterAux.length}
                onChangePage={handleChangePage}
                order={pagination.order === 1 ? 'asc' : 'desc'}
                orderBy={pagination.sort}
                onRequestSort={handleRequestSort}
                noActionDelete
                noActionView
                handleClickAction={handleClickAction}
                />}
        </>
    )
}

export default RegisterVehiclescomponent;
